import React from 'react';
import Flagship from '../../core/flagship';
import * as actions from '../../actions/appActions';
import '../../styles/field.scss';
import {Grid, Checkbox, Label, Input, Icon, Select, Image, Button, TextArea } from 'semantic-ui-react';
import ClientField from './ClientField';
import FlightField from './FlightField';
import FileUploadField from './FileUploadField';
import UserField from './UserField';
import RfpField from './RfpField';
import UserPhoto from '../user/UserPhoto';
import Validate from '../../utils/validate';
import Filter from '../../utils/filter';
import moment from 'moment-business-days';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {throttle, empty, getFormattedValue, randomPassword, uniqueId} from '../../utils/helpers';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

class Field extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = this.getInitialState();

        this.onBlur = this.onBlur.bind(this);
        this.onFocus = this.onFocus.bind(this);

        this.renderField = this.renderField.bind(this);
        this.addInputs = this.addInputs.bind(this);

        this.renderLabel = this.renderLabel.bind(this);
        this.setNewValue = this.setNewValue.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.resetValue = this.resetValue.bind(this);
    }

    getInitialState() {

        let initialValue = this.props.value;

        if (initialValue === null || typeof initialValue === "undefined") {
            initialValue = '';
        }

        if (initialValue === '' && this.props.multi === 1) {
            initialValue = [""];
        }

        let length = initialValue.length > 1 ? initialValue.length : 1;


        let instances = (this.props.multi === true || this.props.multi === 1 ? length : 1 );

        return {
            instances: instances,
            focused: false,
            value: initialValue,
            errors: false,
            errorMessage: '',
            static: false,
            passwordVisible: this.props.visible,
            alreadyChanged: false
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value !== this.props.value) {
            let initialValue = nextProps.value;

            if (initialValue === null || typeof initialValue === "undefined") {
                initialValue = '';
            }

            if (initialValue === '' && nextProps.multi === 1) {
                initialValue = [""];
            }

            let length = initialValue.length > 1 ? initialValue.length : 1;


            let instances = (nextProps.multi === true || nextProps.multi === 1 ? length : 1 );

            this.setState({
                instances: instances,
                value: initialValue,
                alreadyChanged: true
            })
        }
    }

    doValidation(value) {

        if (this.props.hasOwnProperty("validation")) {
            let fn = Validate[this.props.validation];
            if (typeof fn === "function") {

                let validation = fn(value);
                let clearError = this.props.clearError;
                let addError = this.props.addError;
                let fieldId = this.props.id;

                if (validation.valid === true) {
                    this.setState({
                        errors: false,
                        errorMessage: ''
                    }, function() {
                        // Clear error on parent form
                        if (typeof clearError === "function") {
                            clearError(fieldId);
                        }
                    });
                } else {
                    this.setState({
                        errors: true,
                        errorMessage: validation.message
                    }, function() {
                        // Add error on parent form
                        if (typeof addError === "function") {
                            addError(fieldId);
                        }
                    });
                }
            }
        }
    }

    onBlur(e) {

        let fn = Filter[this.props.validation];

        if (typeof fn === "function") {
            this.setState({ focused: false, value: fn(e.target.value) });
        } else {
            this.setState({ focused: false });
        }
        // Run validation again to be safe (in case filter has thrown off validation)
        this.doValidation(e.target.value);
    }

    onFocus(){
        this.setState({ focused: true })
    }

    removeInputs(key) {
        let newValue = this.state.value;
        newValue.splice(key, 1);

        this.setState({
            value: newValue,
            instances: ( this.state.instances > 1 ? this.state.instances - 1 : 1 )
        });
    }

    addInputs() {

        let newValue = this.state.value;

        if (this.props.type!== "option-list") {
            newValue.push("");
        } else {
            newValue.push({
                "key":"",
                "value":"",
                "text":""
            });
        }

        this.setState({
            value:newValue,
            instances:newValue.length
        });
    }

    setNewValue(e, newValue, misc) {

        if ( this.state.alreadyChanged === false) {
            let self = this;

            this.setState(
                {
                    value: '',
                    alreadyChanged: true,
                    passwordVisible: false
                }, function() {

                    self.setState({
                        value: newValue
                    });
                    if (!empty(this.inputRef)) {
                        this.inputRef.focus();
                    }

                }
            );

        } else {
            this.setState(
                {
                    value: newValue
                }
            );
        }

        if (typeof this.props.onChange === "function") {
            this.props.onChange(e, newValue, this.props.id, misc);
        }
    }

    resetValue() {
        this.setState({
            value: (this.props.multi ? [""] : "")
        });
    }


    handleChange(e, data, misc) {

        let newValue; // Initialize new value to be returned

        // Handle dates differently
        if (moment.isMoment(e)) {
            newValue = e.unix();
            this.setNewValue(e, newValue);
            return;
        }

        if (!empty(e)) {
            e.persist();

            if( this.props.validation === "phone") {
                e.target.value = this.formatToPhone(e.target.value);
            }
        }

        // Apply filters first
        if (this.props.hasOwnProperty("filterInput")) {
            let fn = Filter[this.props.filterInput];
            if (typeof fn === "function") {
                e.target.value = fn(e.target.value);
            }
        }

        // Select Field
        if (this.props.type === "select") {
            newValue = data.value;

        } else if (this.props.type === "client") {
            newValue = data.value;
            if (!empty(e)) {
                this.onBlur(e);
            }

        } else if (this.props.type === "rfp") {
            newValue = data.value;
            this.onBlur(e);

            // Checkbox Field
        } else if (this.props.type === "checkbox") {
            newValue = this.state.value;
            if (typeof newValue === "string") {
                newValue = [newValue];
            }
            if (typeof newValue === "string"    && newValue === "")
                newValue = [];
            let isChecked = this.state.value.indexOf(data) !== -1;
            if (!isChecked) {
                newValue.push(data);
            } else {
                const index = newValue.indexOf(data);

                if (index !== -1) {
                    newValue.splice(index, 1);
                }
            }

            // Boolean Field
        } else if (this.props.type === "boolean") {
            newValue = this.state.value === "1" ? "0" : "1";

            // Flight Field
        } else if (this.props.type === "flight") {
            newValue = data;

        } else if (this.props.type === "file") {
            newValue = data;

        } else if (this.props.type === "user") {
            newValue = empty( data.value ) ? '' : data.value;

            // Single String Fields
        } else if (this.props.multi !== true &&
            this.props.multi !== 1 &&
            typeof this.state.value !== "object" ) {
            newValue = e.target.value;

            // Multi-Value Fields
        } else {
            newValue = this.state.value;
            newValue[data] = e.target.value;
        }

        // Validation
        let validate = this.doValidation.bind(this);
        this.timer = throttle( function() {
            validate(newValue);
        }, 800, this.timer);

        this.setNewValue(e, newValue, misc);
    }


    formatToPhone(value) {
        const input = value.replace(/\D/g,'').substring(0,10); // First ten digits of input only
        const area = input.substring(0,3);
        const middle = input.substring(3,6);
        const last = input.substring(6,10);

        if(input.length > 6){return `(${area}) ${middle} - ${last}`;}
        else if(input.length === 6){return `(${area}) ${middle} - `;}
        else if(input.length > 3){return `(${area}) ${middle}`;}
        else if(input.length === 3){return `(${area}) `;}
        else if(input.length > 0){return `(${area}`;}
        return '';
    }

    renderLabel(className = "single-field-label") {
        if ( !empty( this.props.label ) ) {
            return (
                <Label className={className} size="large">
                    {this.props.label}
                    {this.props.required === "1" || this.props.required === true || this.props.required === 1 ?
                        <Icon color="red" size="tiny" className="asterisk" name="asterisk"/>
                        : null
                    }
                </Label>
            );
        }
        return;
    }


    renderField() {

        if (empty(this.attributes)) {
            this.attributes = [];
        }


        if (this.props.hasOwnProperty("options")) {
            let fieldOptions = this.props.options;
            if (!empty(fieldOptions) && typeof fieldOptions.map === "function") {
                fieldOptions.map(function (option, i) {
                    if (typeof option === "string") {
                        fieldOptions[i] = {
                            key: i,
                            value: option,
                            text: option
                        };
                    } else {
                        return option;
                    }
                });
            }
        }

        if ( this.props.type === "select" ) {

            return (
                <div className="flagship-dropdown-select cf">
                    {this.renderLabel()}
                    <Select
                        className="dropdown-select-control cf"
                        onFocus={this.onFocus}
                        onBlur={this.onBlur}
                        placeholder="Select..."
                        options={this.props.options}
                        value={this.state.value}
                        name={this.props.name}
                        search={true}
                        onChange={this.handleChange}
                    />

                </div>
            );


        } else if ( this.props.type === "option-list" ) {

            let field = this;
            return (
                <div className="flagship-group-field">
                    {this.renderLabel()}<br/>
                    <div className="group-values">
                        <Grid stackable columns='four'>
                            <Grid.Column><Label size="large" color="grey">Key</Label></Grid.Column>
                            <Grid.Column><Label size="large" color="grey">Value</Label></Grid.Column>
                            <Grid.Column><Label size="large" color="grey">Text</Label></Grid.Column>
                        </Grid>
                        {!empty(field.state.value) ? field.state.value.map(function (value, key) {
                            if (
                                typeof value !== "undefined" &&
                                value !== null &&
                                (
                                    !value.hasOwnProperty("key") ||
                                    !value.hasOwnProperty("value") ||
                                    !value.hasOwnProperty("text")
                                )
                            ) {

                                value = {
                                    key: this.slugify(value[Object.keys(value)[0]]),
                                    value: value[Object.keys(value)[0]],
                                    text: value[Object.keys(value)[0]]
                                }
                            }
                            return (
                                <Grid key={key} stackable columns='four'>
                                    <Grid.Column>
                                        <Input
                                            placeholder="Key"
                                            type="text"
                                            {...field.attributes}
                                            onFocus={field.onFocus}
                                            onBlur={field.onBlur}
                                            name={field.props.name + '[]'}
                                            onChange={ (e) => {
                                                field.handleChange(e, key);
                                            }}
                                            value={value.key}
                                        />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Input
                                            placeholder="Value"
                                            type="text"
                                            {...field.attributes}
                                            onFocus={field.onFocus}
                                            onBlur={field.onBlur}
                                            name={field.props.name + '[]'}
                                            onChange={ (e) => {
                                                field.handleChange(e, key);
                                            }}
                                            value={value.value}
                                        />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Input
                                            placeholder="Text"
                                            type="text"
                                            {...field.attributes}
                                            onFocus={field.onFocus}
                                            onBlur={field.onBlur}
                                            name={field.props.name + '[]'}
                                            onChange={ (e) => {
                                                field.handleChange(e, key);
                                            }}
                                            value={value.text}
                                        />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Icon className="pointer"
                                              color="red"
                                              size="large"
                                              name="minus circle"
                                              onClick={ () => {
                                                  field.removeInputs(key)
                                              } }/>

                                        <Icon className="pointer"
                                              color="green" size="large"
                                              name="plus circle"
                                              onClick={ () => {
                                                  field.addInputs(key)
                                              } }/>
                                    </Grid.Column>
                                </Grid>

                            );
                        }.bind(this)) : null }
                    </div>

                </div>
            );
        } else if (this.props.type === "boolean") {
            return (
                <div className="flagship-boolean-toggle small-field">
                    {this.renderLabel()}
                    <Checkbox
                        toggle
                        onFocus={this.onFocus}
                        onBlur={this.onBlur}
                        onChange={this.handleChange}
                        checked={this.state.value === "1"}
                        value="1"
                    />
                </div>
            );
        }  else if ( this.props.type === "checkbox") {

            return (
                <div>
                    {this.renderLabel("multi-field-label")}
                    {!empty(this.props.options) ? this.props.options.map(function(option, key) {

                        let addAdditionalValues =
                            this.props.type === "text" &&
                            (this.props.multi === true || this.props.multi === 1);

                        let isChecked = this.state.value === false ? false : this.state.value.indexOf(option.value) !== -1;

                        return (
                            <div key={key}>
                                <Checkbox
                                    key={"checkbox-" + key}
                                    className="checkbox"
                                    toggle={true}
                                    checked={isChecked}
                                    label={option.text}
                                    id={this.props.name + '-option-' + key}
                                    value={option.value}
                                    onFocus={this.onFocus}
                                    onBlur={this.onBlur}
                                    onChange={(e) => this.handleChange(e, option.value)}

                                />
                                {addAdditionalValues ?
                                    <Icon className="pointer"
                                          color="red" size="large"
                                          name="minus circle"
                                          onClick={() => {
                                              this.removeInputs(key)
                                          }}/>
                                    : null}
                                {addAdditionalValues ?
                                    <Icon className="pointer"
                                          color="green" size="large"
                                          name="plus circle"
                                          onClick={() => {
                                              this.addInputs(key)
                                          }}/>
                                    : null}
                            </div>
                        );
                    }.bind(this)) : null}

                </div>
            );
        } else if (this.props.validation === "date") {

            let minDate = null;
            if (!empty(this.props.minDatePadding)) {
                minDate = moment().businessAdd(this.props.minDatePadding, "days");
            }

            return (
                <div className="small-field">
                    <div className="field-container clearfix">
                        <div className="ui fluid input">
                            {this.renderLabel()}
                            <DatePicker
                                label={this.props.label}
                                onFocus={this.onFocus}
                                onBlur={this.onBlur}
                                fluid
                                minDate={minDate}
                                value={this.state.value !== "" ? getFormattedValue(this.state.value, this.props.validation) : ""}
                                name={this.props.name}
                                placeholder={ this.props.hasOwnProperty("placeholder") ? this.props.placeholder : ''}
                                onChange={(e) => {
                                    this.handleChange(e);
                                }}
                            />
                        </div>

                    </div>
                </div>
            );
        } else if (this.props.type === "textarea") {

            return (
                    <div>
                        {this.renderLabel()}
                        <TextArea
                            autoHeight
                            placeholder={this.props.hasOwnProperty("placeholder") ? this.props.placeholder : ''}
                            {...this.props.attributes}
                            onFocus={this.onFocus}
                            onBlur={this.onBlur}
                            name={this.props.name}
                            onChange={(e) => {

                                this.handleChange(e);
                            }}
                            value={String(this.state.value)}
                        />
                    </div>
                );

        } else if (this.props.type === "user") {

            return (
                <div className="field-container clearfix">
                    <UserField
                        placeholder={ this.props.hasOwnProperty("placeholder") ? this.props.placeholder : ''}
                        {...this.props.attributes}
                        onFocus={this.onFocus}
                        onBlur={this.onBlur}
                        label={this.props.label}
                        required={this.props.required}
                        preventFocus={true}
                        name={this.props.name}
                        userData={this.state.value}
                        onChange={ (e, data) => { this.handleChange(e, data); }}
                        onReset={this.resetValue.bind(this)}
                        value={this.state.value}
                    />
                </div>
            );

        } else if (this.props.type === "client") {

            const onAddClient = (id, link, key, name) => {
                this.handleChange(null, {value: {id, type: "client", link, key, name}});
            };

            return (
                <div className="field-container clearfix">
                    <ClientField
                        placeholder={ this.props.hasOwnProperty("placeholder") ? this.props.placeholder : ''}
                        {...this.props.attributes}
                        onFocus={this.onFocus}
                        onBlur={this.onBlur}
                        label={this.props.label}
                        required={this.props.required}
                        name={this.props.name}
                        onAddClient={onAddClient}
                        onChange={ (e, data) => { this.handleChange(e, data); }}
                        onReset={this.resetValue.bind(this)}
                        value={this.state.value}
                    />
                </div>
            );
        } else if (this.props.type === "rfp") {

            return (
                <div className="field-container clearfix">
                    { this.renderLabel()}

                    <RfpField
                        placeholder={ this.props.hasOwnProperty("placeholder") ? this.props.placeholder : ''}
                        {...this.props.attributes}
                        onFocus={this.onFocus}
                        onBlur={this.onBlur}
                        name={this.props.name}
                        onChange={ (e, data) => { this.handleChange(e, data); }}
                        value={this.state.value}
                    />
                </div>
            );
        } else if (this.props.type === "note") {

            return (
                <Label color="blue">
                    <Icon circular name="info" />
                    {this.props.label}
                    <div style={{marginTop:"10px"}} dangerouslySetInnerHTML={{__html: this.props.default}}/>
                </Label>
            )
        } else if (this.props.type === "html") {

            return (
                <div>
                    {!empty(this.props.label) ?
                    <Label color="blue">
                        <Icon circular name="info" />
                        {this.props.label}
                        {this.props.default}
                    </Label> : null}
                    <div style={{marginTop:"1em"}} dangerouslySetInnerHTML={{__html: this.props.details}}/>
                </div>
            )
        } else if (this.props.type === "flight") {

            return(
                <div className="flight-field-container clearfix">

                    <FlightField {...this.props.attributes} value={this.state.value} onChange={ (e, data) => { this.handleChange(e, data, "flight"); }}/>

                </div>
            );
        } else if (this.props.type === "file") {

            let folder = ( !empty( this.props.value ) ? this.props.value : "fields/" + this.props.id + "/" + uniqueId() );

            return(
                <div className="file-field-container clearfix">

                    <FileUploadField folder={folder} {...this.props} onChange={ (e, data) => { this.handleChange(e, data, "file"); }} />

                </div>
            );


        } else if (this.props.type === "userPhoto") {

            if (!empty(this.state.value)) {

                return (
                    <div>
                        {this.renderLabel("multi-field-label")}
                        <div className="field-container clearfix">
                            <div className="user-photo-field">
                                <Image
                                    src={Flagship.config.uploads + this.state.value + '?cb=' + Math.floor(Math.random() * 999999)}
                                    alt="User Photo"/>
                            </div>
                        </div>
                        <Button onClick={() => this.setState({value: ''})} secondary content="Edit Photo"/>
                    </div>
                )
            }

            let self = this;

            const newFileUploaded = () => {
                let newValue = this.props.default + '?cb=' + Math.floor(Math.random() * 999999);

                this.setState(
                    {
                        value: newValue
                    }, function () {
                        self.props.onChange(newValue);
                        self.props.actions.checkToken(this.props.token);
                    }
                );

            };


            return (
                <div>
                    {this.renderLabel("multi-field-label")}
                    <div className="field-container clearfix">
                        <UserPhoto
                            username={this.props.username}
                            photo={Flagship.config.uploads + this.props.default + '?cb=' + Math.floor(Math.random() * 999999)}
                            onSave={newFileUploaded}
                        />
                    </div>
                </div>
            );
        } else if (this.props.type === "password") {

            const togglePasswordVisible = () => {
                this.setState( {
                    passwordVisible: !this.state.passwordVisible
                });
            };

            const generatePassword = () => {
                this.setState( {
                    value: randomPassword()
                });
            };

            let passwordIcon = () => {
                return (
                    <Icon
                        name={this.state.passwordVisible === true ? "hide" : "unhide"}
                        circular={true}
                        link={true}
                        onClick={togglePasswordVisible}
                    />
                );
            };

            return (
                <div className="password-input-container">
                    <Input
                        ref={input => (this.inputRef = input)}
                        className="single-password-input"
                        type={this.state.passwordVisible === true ? "text" : "password"}
                        name="password"
                        label="New Password"
                        icon={passwordIcon()}
                        placeholder={this.props.placeholder ? this.props.placeholder : "Leave blank to avoid changing"}
                        value={this.state.value}
                        onChange={(e) => {this.handleChange(e); }}
                    />

                    <Button
                        className="single-generate-password-button"
                        onClick={generatePassword}
                        secondary
                        content="Generate Password..."
                    />
                </div>
            )

        } else {

            let multiField = this.props.multi === true || this.props.multi === 1;
            let addAdditionalValues = this.props.type === "text" && multiField;
            let attributes = [];
            if(!empty(this.props.attributes)) {
                attributes = this.props.attributes;
            }
            return (
                <div>
                    {multiField ? this.renderLabel("multi-field-label") : this.renderLabel()}
                    { Array.apply(null, {length: this.state.instances}).map(function(b, key) {

                        if (!empty(this.props.prefix) || !empty(this.props.suffix)){

                            return (
                                <div className="field-container clearfix" key={key}>
                                    <Input
                                        fluid
                                        labelPosition={empty(this.props.suffix) ? "left" : "right"}
                                        placeholder={this.props.hasOwnProperty("placeholder") ? this.props.placeholder : ''}
                                        type={this.props.type}
                                        {...attributes}
                                        onFocus={this.onFocus}
                                        onBlur={this.onBlur}
                                        name={this.props.name}
                                        onChange={(e) => {
                                            this.handleChange(e, key);
                                        }}
                                        value={typeof this.state.value === "object" ? getFormattedValue(this.state.value[key], this.props.validation) : getFormattedValue(this.state.value, this.props.validation)}
                                        className={addAdditionalValues ? 'add-remove-values-field' : null}
                                    >
                                        {!empty(this.props.prefix) ? <Label basic>{this.props.prefix}</Label> : null}
                                        <Input/>
                                        {!empty(this.props.suffix) ? <Label>{this.props.suffix}</Label> : null}
                                    </Input>

                                    {addAdditionalValues ?
                                        <div className="add-remove-values-icons">
                                            <Icon className="pointer minus"
                                                  size="large"
                                                  name="minus circle"
                                                  onClick={() => {
                                                      this.removeInputs(key)
                                                  }}/>
                                            <Icon className="pointer plus"
                                                  size="large"
                                                  name="plus circle"
                                                  onClick={() => {
                                                      this.addInputs(key)
                                                  }}/>
                                        </div>
                                        : null}
                                </div>
                            );
                        } else {

                            return (
                                <div className="field-container clearfix" key={key}>
                                    <Input
                                        fluid
                                        placeholder={this.props.hasOwnProperty("placeholder") ? this.props.placeholder : ''}
                                        type={this.props.type}
                                        {...this.props.attributes}
                                        onFocus={this.onFocus}
                                        onBlur={this.onBlur}
                                        name={this.props.name}
                                        onChange={(e) => {

                                            this.handleChange(e, key);
                                        }}
                                        value={typeof this.state.value === "object" ? getFormattedValue(this.state.value[key], this.props.validation) : getFormattedValue(this.state.value, this.props.validation, null, 'edit')}
                                        className={addAdditionalValues ? 'add-remove-values-field' : null}
                                    />

                                    {addAdditionalValues ?
                                        <div className="add-remove-values-icons">
                                            <Icon className="pointer minus"
                                                  size="large"
                                                  name="minus circle"
                                                  onClick={() => {
                                                      this.removeInputs(key)
                                                  }}/>
                                            <Icon className="pointer plus"
                                                  size="large"
                                                  name="plus circle"
                                                  onClick={() => {
                                                      this.addInputs(key)
                                                  }}/>
                                        </div>
                                        : null}
                                </div>
                            );
                        }
                    }.bind(this)) }

                </div>
            );
        }
    }

    render() {

        if(!empty(this.props.role_required)) {
            if(this.props.userRole !== this.props.role_required && this.props.userRole !== "admin") {
                return null;
            }
        }
        return (
            <div className={
                this.props.type === 'hidden' ? 'flagship-single-field flagship-hidden-field' : 'flagship-single-field' +
                    (this.state.focused ? ' focused' : '') +
                    ' field-type-' + this.props.type}>
                <div className={ "flagship-input " + (this.state.errors !== false ? "has-errors" : "valid")  +
                (this.props.validation === "money" || this.props.validation === "numeric" || this.props.validation === "phone" ? " small-field" : "")}>
                    {this.renderField()}
                </div>
                {this.state.errors !== false ?
                    <Label
                        color="red"
                        className="flagship-field-error-message"
                        pointing >
                        <div className="flexbox">
                            <div className="top" />
                            <div className="middle">{this.state.errorMessage}</div>
                            <div className="bottom" />
                        </div>
                    </Label> : null }
                {this.state.errors === false && this.state.value === "" && this.props.hasOwnProperty("details") && this.props.details !== "" && this.props.details !== null ?
                    <Label
                        color="blue"
                        className={ "field-details " + (this.state.focused ? "visible" : "hidden") }
                        pointing >
                        <div className="flexbox">
                            <div className="top" />
                            <div className="middle">{this.props.details}</div>
                            <div className="bottom" />
                        </div>
                    </Label> : null }
            </div>
        );

    }

}

function mapStateToProps(state) {
    return {
        token: state.main.token,
        username: state.main.username,
        userId: state.main.userId,
        userRole: state.main.userRole
    };
}

function mapDispatchToProps(dispatch) {

    return {
        actions: bindActionCreators(actions, dispatch)
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Field);




// WEBPACK FOOTER //
// ./src/components/records/Field.js